const state = {
  myLocation: {
    latitude: 0.0,
    longitude: 0.0,
  },
  tgtLocation: {
    latitude: 0.0,
    longitude: 0.0,
  },
  distBtw: 999,
  distBtw_ts: null,
  new_ts:null,
  isLiveTracking: false,
  watchId: null,
  radiusLimit: 10,
  validityPeriod : 300000,
};

const getters = {
  myLocation: (state) => state.myLocation,
  tgtLocation: (state) => state.tgtLocation,
  distBtw: (state) => state.distBtw,
  distBtw_ts: (state) => state.distBtw_ts,
  isLiveTracking: (state) => state.isLiveTracking,
  radiusLimit: (state) => state.radiusLimit,
  isWithinRadius: (state) => {
    if (state.distBtw <= 0.1 && state.distBtw_ts !== null) {
      // let currentTime = new Date();
      const timeDifference = state.new_ts - state.distBtw_ts;
       //5 * 60 * 1000; // 5 minutes in milliseconds
      return timeDifference <= state.validityPeriod;
    }
    return false;
  },

};

const mutations = {
  setMyLocation(state, payload) {
    state.myLocation.latitude = payload.latitude;
    state.myLocation.longitude = payload.longitude;
  },
  setTgtLocation(state, payload) {
    state.tgtLocation = payload;
  },
  setDistBtw(state, payload) {
    state.distBtw = payload;
  },
  setdistBtw_ts(state, payload) {
    state.distBtw_ts = payload;
  },
  setisLiveTracking(state, payload) {
    state.isLiveTracking = payload;
  },
  setnew_ts(state, payload){
    state.new_ts = payload;
  }
};

const actions = {
  startLocationTracking({ commit, state, dispatch }) {
    commit("setisLiveTracking", true);
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    const success = async (position) => {
      const myLoc = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
        commit("setMyLocation", myLoc);
        await dispatch("getDistBetween");
        commit('SET_LOCATION_STATE', 'granted');
      };
      const error = (err) => {
        console.warn(`ERROR(${err.code}): ${err.message}`);
        commit('SET_LOCATION_STATE', 'denied');
      };
    state.watchId = navigator.geolocation.watchPosition(success, error, options);
  },
  stopLocationTracking({ state, commit }) {
    if (!state.isLiveTracking) {
      return;
    }
    commit("setisLiveTracking", false);    
    navigator.geolocation.clearWatch(state.watchId);
  },
  toggleLiveLocation({ state, dispatch }) {
    if (!state.isLiveTracking) {
      dispatch('stopLocationTracking')
      
    }
    else {   
      dispatch('startLocationTracking')
      dispatch('app/checkLocationPermission');
    }
    dispatch('app/checkLocationPermission',null,{root:true});
  },
  getMyLocation({ commit }) {
    navigator.geolocation.getCurrentPosition((position) => {
      const myLoc = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
      commit("setMyLocation", myLoc);
    });
  },
  getTgtLocation({ commit }, payload) {
    const tgtLoc = payload;
    commit("setTgtLocation", tgtLoc);
  },
  getDistBetween({ commit, state }) {
    const myLat = state.myLocation.latitude;
    const myLon = state.myLocation.longitude;
    const tgtLat = state.tgtLocation.latitude;
    const tgtLon = state.tgtLocation.longitude;

    const toRadians = (degrees) => {
      return degrees * (Math.PI / 180);
    };

    const R = 6371; // Radius of the Earth in kilometers

    const dLat = toRadians(tgtLat - myLat);
    const dLon = toRadians(tgtLon - myLon);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(myLat)) *
        Math.cos(toRadians(tgtLat)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = R * c; // Distance in kilometers

    commit("setDistBtw", distance.toFixed(2));
    let timeStamp = new Date();
    commit("setdistBtw_ts", timeStamp);
  },
  setNew_ts({ commit }){
    let currentTime = new Date();
    commit("setnew_ts", currentTime);
  },
  clearDistBtw({ commit }) {
    commit("setDistBtw", 999);
  },
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};



// const initialState = () =>({
//   myLocation: {
//     latitude: 0.0,
//     longitude: 0.0,
//   },
//   tgtLocation: {
//     latitude: 0.0,
//     longitude:0.0,
//   },
//   distBtw: 999,
//   distBtw_ts:new Date(),
//   isLiveTracking: false,
//   watchId:null,
// });

// const state = initialState();


// const state = {
//   myLocation: {
//     latitude: 0.0,
//     longitude: 0.0,
//   },
//   tgtLocation: {
//     latitude: 0.0,
//     longitude: 0.0,
//   },
//   distBtw: 999,
//   distBtw_ts:null,
//   isLiveTracking: false,
//   watchId:null,
// };

// const getters = {
//   myLocation: (state) => state.myLocation,
//   tgtLocation: (state) => state.tgtLocation,
//   distBtw: (state) => state.distBtw,
//   distBtw_ts: (state) => state.distBtw_ts,
//   isLiveTracking: (state) => state.isLiveTracking,
// };

// const mutations = {
//   setMyLocation(state, payload) {
//     state.myLocation.latitude = payload.latitude;
//     state.myLocation.longitude = payload.longitude;
//   },
//   setTgtLocation(state, payload) {
//     state.tgtLocation = payload;
//   },
//   setDistBtw(state, payload) {
//     state.distBtw = payload; 
//   },
//   setdistBtw_ts(state,payload){
//     state.distBtw_ts = payload;
//   },  
//   setisLiveTracking(state,payload){
//     state.isLiveTracking =payload
//   },  
//   // RESET_STATE(state) {
//   //   const newState = initialState();
//   //   Object.keys(newState).forEach(key => {
//   //     state[key] = newState[key];
//   //   });
//   // },
// };

// const actions = {
//   startLocationTracking({ commit,state,dispatch }) {
//     commit("setisLiveTracking",true)
//     const options = {
//       enableHighAccuracy: true,
//       timeout: 5000,
//       maximumAge: 0,
//     };
//     const success = async(position) => {
//       const myLoc = {
//         latitude: position.coords.latitude,
//         longitude: position.coords.longitude,
//       };
//       console.log('async')
//       commit("setMyLocation", myLoc);      
//       await dispatch("getDistBetween");  
//     };
//     const error = (err) => {
//       console.warn(`ERROR(${err.code}): ${err.message}`);
//     };
//     state.watchId = navigator.geolocation.watchPosition(success, error, options);    
//   },
//   stopLocationTracking({state, commit }) {
//     if (!state.isLiveTracking) {      
//       return;
//     }    
//     commit("setisLiveTracking",false)
//     let timeStamp =  new Date()
//     commit("setdistBtw_ts",timeStamp);
//     navigator.geolocation.clearWatch(state.watchId);    
//   },
//   getMyLocation({ commit }) {
//     navigator.geolocation.getCurrentPosition((position) => {
//       const myLoc = {}
//       myLoc.latitude = position.coords.latitude
//       myLoc.longitude = position.coords.longitude
//       commit("setMyLocation", myLoc);
//     });
//   },
//   getTgtLocation({ commit }, payload) {
//     const tgtLoc = payload;
//     console.log("tgtloc",tgtLoc)
//     commit("setTgtLocation", tgtLoc);
//   },
//   getDistBetween({ commit }) {
//     const  myLat = state.myLocation.latitude;
//     const  myLon = state.myLocation.longitude;
//     const tgtLat = state.tgtLocation.latitude;
//     const tgtLon = state.tgtLocation.longitude;

//     const  myX = (myLon - 54.286528) / 0.009;
//     const  myY = (myLat - 23.949725) / 0.009;
//     console.log(myX,myY)
//     const tgtX = (tgtLon - 54.286528) / 0.009;
//     const tgtY = (tgtLat - 23.949725) / 0.009;
//     console.log(tgtX,tgtY)
//     const  distBtw = (((myX - tgtX) ** 2 + (myY - tgtY) ** 2)**.5).toFixed(2);
    
//     if (state.distBtw != distBtw )
//     commit("setDistBtw", distBtw );      
//     setTimeout(() => {
//       console.log(state.distBtw)
//     }, 50000);
//       // if (tgtLat >= 0.0 || tgtLon >= 0.0)    
//       // dist.distBtw  = distBtw
//       // dist.timeStamp =  new Date()
   
//   },
//   clearDistBtw ({ commit }) {
//     commit("setDistBtw", 999)
//   },
// };

// export default {
//   namespace: true,
//   state,
//   getters,
//   actions,
//   mutations,
// };
